import { render, staticRenderFns } from "./BusinessCaseSb.vue?vue&type=template&id=479a493e&scoped=true"
import script from "./BusinessCaseSb.vue?vue&type=script&lang=js"
export * from "./BusinessCaseSb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a493e",
  null
  
)

export default component.exports